import React from 'react'

const DeleteConfirmationModal = ({ handleDeleteItem,groupId,expenseId,onClose }) => {
    const handleDeleteConfirm = () => {
      // Execute the delete action
      handleDeleteItem(groupId,expenseId);
    };
  
    return (
      <div className="fixed inset-0 flex items-center justify-center z-50 overflow-auto bg-gray-900 bg-opacity-50">
        <div className="bg-white rounded-lg p-8 max-w-md w-full">
            <h2 className="text-lg font-bold mb-4">Confirm Delete</h2>
            <p className="mb-6">Are you sure you want to delete?</p>
            <div className="flex justify-end">
                <button className="mr-2 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600" onClick={handleDeleteConfirm}>Yes</button>
                <button className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400" onClick={()=>onClose()}>No</button>
            </div>

        </div>
      </div>
    );
  };
export default DeleteConfirmationModal;